var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 8.092a7.083 7.083 0 0 0-.759-3.442 2.433 2.433 0 0 0-1.433-.833A65.3 65.3 0 0 0 10 3.558c-2.32-.04-4.64.044-6.95.25-.457.083-.88.298-1.216.617C1.084 5.117 1 6.3.917 7.3a40.242 40.242 0 0 0 0 5.4 7.96 7.96 0 0 0 .25 1.667c.1.42.304.81.592 1.133.339.336.772.563 1.241.65 1.797.222 3.607.314 5.417.275 2.917.042 5.475 0 8.5-.233a2.401 2.401 0 0 0 1.275-.65c.233-.234.407-.52.508-.834a8.817 8.817 0 0 0 .434-2.833c.033-.467.033-3.283.033-3.783zm-11.05 4.283V7.217l4.933 2.591c-1.383.767-3.208 1.634-4.933 2.567z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.434718654486353a20f4aea97ead6eed.svg";
export { ForwardRef as ReactComponent };